import React from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Tabs, Tab } from 'components/shared/Tabs'
import SamgovUsage from 'components/RoxAdmin/SamgovUsage'
import NppesUsage from 'components/RoxAdmin/NppesUsage'
import LeieUsage from 'components/RoxAdmin/LeieUsage'
import OfacUsage from 'components/RoxAdmin/OfacUsage'
import StateMedicaidUsage from 'components/RoxAdmin/StateMedicaidUsage'

// One tab per data source; `key` is what ?tab= holds so a tab can be linked to directly
const SOURCES = [
    { key: 'samgov', label: 'SAM.gov', Component: SamgovUsage },
    { key: 'nppes', label: 'NPI Registry (NPPES)', Component: NppesUsage },
    { key: 'leie', label: 'HHS OIG (LEIE)', Component: LeieUsage },
    { key: 'ofac', label: 'OFAC (SDN)', Component: OfacUsage },
    { key: 'state-medicaid', label: 'State Medicaid', Component: StateMedicaidUsage },
]

/**
 * Data-source admin surfaces (SAM.gov, NPPES, LEIE, OFAC, State Medicaid) as tabs on one page.
 * The old /settings/*-usage routes still render each source on its own.
 */
const DataSourcesHub = () => {
    const location = useLocation()
    const history = useHistory()
    const tabKey = new URLSearchParams(location.search).get('tab')
    const tabValue = Math.max(0, SOURCES.findIndex(source => source.key === tabKey))

    const handleChange = (e, value) => {
        const params = new URLSearchParams(location.search)
        params.set('tab', SOURCES[value].key)
        history.replace({ search: params.toString() })
    }

    return (
        <>
            <div className='mb-3'>
                <Link to='/settings' className='text-decoration-none' style={{ fontSize: 13, color: '#666' }}>
                    ← Settings
                </Link>
                <h4 className='mb-1 mt-2'>Data Sources</h4>
                <div style={{ fontSize: 14, color: '#666' }}>
                    Local mirrors of federal registries and exclusion lists used by the underwriting pipeline.
                </div>
            </div>
            {/* ids match the panels' aria-labelledby (nav-tab-N) set by the shared Tab component */}
            <Tabs
                data={SOURCES.map((source, index) => ({
                    label: source.label,
                    id: `nav-tab-${index}`,
                    'aria-controls': `nav-tabpanel-${index}`,
                }))}
                value={tabValue}
                onChange={handleChange}
                scrollable
            />
            {SOURCES.map(({ key, Component }, index) => (
                <Tab key={key} value={tabValue} index={index} className='mt-3'>
                    <Component />
                </Tab>
            ))}
        </>
    )
}

export default DataSourcesHub
